import React from "react";
import { useTranslation } from "react-i18next";
import ApmLink from "src/ui/shared/ApmLink";

import { Box, Typography } from "@mui/material";

interface Props {
    title: string;
    text: string;
}

const BasePage = (props: Props) => (
    <Box style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", width: "100%" }}>
        <div style={{ textAlign: "center" }}>
            <Typography variant="h4">{props.title}</Typography>
            <ApmLink href="https://emteria.com">
                <Typography variant="h6">{props.text}</Typography>
            </ApmLink>
        </div>
    </Box>
);

export const PageForbidden = () => {
    const { t } = useTranslation(["pages"]);

    return <BasePage title={t("pages:errorPage.forbidden")} text={t("pages:errorPage.goToMainPage")} />;
};

export const PageNotFound = () => {
    const { t } = useTranslation(["pages"]);

    return <BasePage title={t("pages:errorPage.notFound")} text={t("pages:errorPage.goToMainPage")} />;
};
